import React, { useEffect, useState } from 'react';
import Title from '../layouts/Title';
import ContactLeft from './ContactLeft';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [send, setSend] = useState({
    to_name: "Fourat Abdellatif",
    subject: "",
    message: "",
    from_name: "",
    from_email: "",
    from_phone: ""
  });
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isFading, setIsFading] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (successMsg) {
      const fadeTimer = setTimeout(() => setIsFading(true), 4500);
      const removeTimer = setTimeout(() => {
        setSuccessMsg('');
        setIsFading(false);
      }, 5000);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [successMsg]);

  const emailValidation = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSend((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearForm = () => {
    setSend({
      to_name: "Fourat Abdellatif",
      subject: "",
      message: "",
      from_name: "",
      from_email: "",
      from_phone: ""
    });
  };

  const handleSend = async (e) => {
    e.preventDefault();
    const { from_name, from_phone, from_email, subject, message } = send;

    if (!from_name) return setErrMsg("Name is required!");
    if (!from_phone) return setErrMsg("Phone number is required!");
    if (!from_email) return setErrMsg("Please give your Email!");
    if (!emailValidation(from_email)) return setErrMsg("Provide a valid Email!");
    if (!subject) return setErrMsg("Please provide a Subject!");
    if (!message) return setErrMsg("Message is required!");

    try {
      setLoader(true);
      setErrMsg("");

      await emailjs.send(
        "gmail",
        "template_wyn02qk",
        send,
        "a7SuU_JlEsPj9UcPn"
      );

      setSuccessMsg(`Thank you, ${from_name}. Your message has been sent successfully!`);
      clearForm();
    } catch (error) {
      setErrMsg("An error occurred. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <section id="contact" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact Me" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <ContactLeft />
          <div className="w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] flex flex-col gap-8 p-4 lgl:p-8 rounded-lg shadow-shadowOne">
            <form onSubmit={handleSend} className="w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl:py-5">
              <div className="w-full flex flex-col lgl:flex-row gap-10">
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  <p className="text-sm text-gray-400 uppercase tracking-wide">Name</p>
                  <input
                    name="from_name"
                    value={send.from_name}
                    onChange={handleChange}
                    className={`contactInput ${errMsg === "Name is required!" && "outline-designColor"}`}
                    type="text"
                  />
                </div>
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  <p className="text-sm text-gray-400 uppercase tracking-wide">Phone Number</p>
                  <input
                    name="from_phone"
                    value={send.from_phone}
                    onChange={handleChange}
                    className={`contactInput ${errMsg === "Phone number is required!" && "outline-designColor"}`}
                    type="text"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-sm text-gray-400 uppercase tracking-wide">Email</p>
                <input
                  name="from_email"
                  value={send.from_email}
                  onChange={handleChange}
                  className={`contactInput ${errMsg === "Please give your Email!" && "outline-designColor"}`}
                  type="email"
                />
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-sm text-gray-400 uppercase tracking-wide">Subject</p>
                <input
                  name="subject"
                  value={send.subject}
                  onChange={handleChange}
                  className={`contactInput ${errMsg === "Please provide a Subject!" && "outline-designColor"}`}
                  type="text"
                />
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-sm text-gray-400 uppercase tracking-wide">Message</p>
                <textarea
                  name="message"
                  value={send.message}
                  onChange={handleChange}
                  className={`contactTextArea ${errMsg === "Message is required!" && "outline-designColor"}`}
                  cols="30"
                  rows="8"
                ></textarea>
              </div>
              <div className="w-full">
                {loader ? (
                  <div role="status" style={{
                    margin: "0 auto",
                    display: "block",
                    width: "fit-content",
                  }}>
                    <svg className="w-8 h-8 text-transparent animate-spin fill-designColor" viewBox="0 0 100 101" fill="none">
                      <path d="M100 50.6C100 78.2 77.6 100.6 50 100.6 22.4 100.6 0 78.2 0 50.6 0 23 22.4 0.6 50 0.6c27.6 0 50 22.4 50 50Z" fill="currentColor" />
                      <path d="M93.97 39c2.43-.64 3.9-3.14 3.05-5.5-1.72-4.73-4.14-9.19-7.2-13.24C86.84 15.12 81.88 10.72 76.21 7.41 70.54 4.1 64.28 1.94 57.77 1.05 52.77.37 47.7.45 42.73 1.28c-2.47.42-4.02 2.92-3.38 5.35.63 2.42 3.11 3.85 5.6 3.48 3.8-.56 7.67-.58 11.5 0.05 5.32.73 10.45 2.5 15.1 5.2 4.66 2.7 8.78 6.4 12.1 10.9 2.42 3.24 4.45 6.74 6.05 10.43.96 2.3 3.5 3.71 5.9 3.07Z" fill="currentFill" />
                    </svg>
                  </div>
                ) : (
                  <button className="w-full h-12 bg-[#141518] rounded-lg text-base text-gray-400 tracking-wider hover:text-white hover:border-[1px] hover:border-designColor duration-300">
                    Send Message
                  </button>
                )}
              </div>
              {errMsg && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-orange-500 text-base tracking-wide">
                  {errMsg}
                </p>
              )}
              {successMsg && (
                <p
                  className={`py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-green-500 text-base tracking-wide transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
                >
                  {successMsg}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
